'use client'

import * as React from 'react'
import { CommentButton } from '@web/app/[locale]/clubhouse/[slug]/_components/action-buttons/comment-button'

interface Props {
  onClick?: () => void
  size?: 'small' | 'regular'
  commentCount: number
}

export const ProjectCommentButton = ({ size, onClick, commentCount }: Props) => {
  return <CommentButton size={size} commentCount={commentCount} onClick={() => onClick?.()} />
}
